<app-delivery-date-time [selectedDate]="data.deliveryDate" [pickupDays]="data.pickupDays" (selectedDateChange)="onSelectedDateChange($event)" ></app-delivery-date-time>
